import React, { useRef, useState, useEffect } from "react";
import { Button, Card, Container, Row, Col } from "reactstrap";
import { QRCodeCanvas } from "qrcode.react";
import { useNavigate } from "react-router-dom";
import html2canvas from "html2canvas";
// import OrganizationService from "../../../../Services/QRCodeServices/OrganizationManagement/OrganizationService";
import sebs from "../../../assets/orderingSystem/logo.png";
import { useParams } from "react-router-dom";
import "./QrModalV1.css";
import OrganizationService from "../../../services/OrderingServices/OrganizationService";
import BreadCrumb from "../../../Components/Common/BreadCrumb";

export const QRModalV1 = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const modalRef = useRef(null);
  const qrCodeRef = useRef(null);
  const [data, setData] = useState([]);
  const [downloading, setDownloading] = useState(false);
  const user = JSON.parse(localStorage.getItem("user"));
  const orgCode = user?.organizationInfo?.orgCode || data?.orgCode;
  const url = `${window.location.origin}/${orgCode}?source=qr-menu`;
  const proxyUrl = `https://api.qrmenu.asia/api/proxy`;

  const [imageSrc, setImageSrc] = useState(null);

  useEffect(() => {
    const fetchDetail = async () => {
      try {
        const response = await OrganizationService.detail(id);
        setData(response);
        if (response?.cloudR2ImagePath) {
          const img = new Image();
          img.crossOrigin = "anonymous";
          img.src = response.cloudR2ImagePath.getCDNUrl();
          img.onload = () => {
            const canvas = document.createElement("canvas");
            const ctx = canvas.getContext("2d");
            canvas.width = img.naturalWidth;
            canvas.height = img.naturalHeight;
            ctx.drawImage(img, 0, 0);
            const dataUrl = canvas.toDataURL("image/png");
            setImageSrc(dataUrl);
          };
        }
      } catch (error) {
        console.log(error);
      }
    };
    fetchDetail();
  }, [id]);

  const handlePrint = async () => {
    if (!modalRef.current) {
      console.error("Modal ref is not available");
      return;
    }

    try {
      const modalElement = modalRef.current;

      const canvas = await html2canvas(modalElement, {
        scale: 2,
        // useCORS: true,
        backgroundColor: "#f0f7ff",
        proxy: proxyUrl,
        logging: false,
      });

      const printWindow = window.open("", "_blank");
      if (!printWindow) {
        alert("Please allow popups to print");
        return;
      }

      printWindow.document.write(`
        <html>
          <head>
            <title>Print QR Code</title>
            <style>
              @media print {
                body {
                  margin: 0;
                  padding: 0;
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  height: 100vh;
                  width: 100%;
                }
                img {
                  width: 100%;
                  height: auto;
                }
              }
            </style>
          </head>
          <body>
            <img src="${canvas.toDataURL("image/jpeg", 1.0)}" />
            <script>
              window.onload = function() {
                window.print();
                window.onafterprint = function() {
                  window.close();
                }
              }
            </script>
          </body>
        </html>
      `);
      printWindow.document.close();
    } catch (error) {
      console.error("Error printing:", error);
    }
  };

  const handleDownload = async () => {
    if (!modalRef.current) {
      console.error("Modal ref is not available");
      return;
    }

    try {
      setDownloading(true);

      const images = modalRef.current.querySelectorAll("img");
      await Promise.all(
        Array.from(images).map((img) => {
          return new Promise((resolve, reject) => {
            if (img.complete) {
              resolve();
            } else {
              img.onload = resolve;
              img.onerror = reject;
            }
          });
        })
      );

      const qrCodeCanvas = qrCodeRef.current.querySelector("canvas");
      const qrCodeImgSrc = qrCodeCanvas?.toDataURL("image/png");

      const clone = modalRef.current.cloneNode(true);
      const qrCodeDiv = clone.querySelector(".p-3.text-center");
      const qrCodeImg = document.createElement("img");
      qrCodeImg.src = qrCodeImgSrc;
      qrCodeImg.style.width = "100px";
      qrCodeImg.style.height = "100px";
      qrCodeImg.alt = "QR Code";
      qrCodeDiv.replaceChild(qrCodeImg, qrCodeDiv.firstChild);

      const logoImg = clone.querySelector("img[alt='Organization Logo']");
      if (logoImg && imageSrc) {
        logoImg.src = imageSrc;
      }

      clone.style.position = "absolute";
      clone.style.left = "-9999px";
      document.body.appendChild(clone);

      const canvas = await html2canvas(clone, {
        scale: 2,
        proxy: proxyUrl,
        // useCORS: true,
        backgroundColor: "#ffffff",
      });

      document.body.removeChild(clone);

      canvas.toBlob((blob) => {
        if (blob) {
          const link = document.createElement("a");
          link.href = URL.createObjectURL(blob);
          link.download = `${data?.name || "qr-code"}-menu.jpg`;
          link.click();
          URL.revokeObjectURL(link.href);
        }
        setDownloading(false);
      }, "image/jpeg");
    } catch (error) {
      console.error("Download failed:", error);
      alert("Failed to download image. Please try again.");
      setDownloading(false);
    }
  };

  return (
    <div className="page-content">
      <div className="container-fluid">
        <BreadCrumb title="Napkin QR Menu" pageTitle="Dashboard" />
      </div>

      <div className="qr-small-modal-container">
        <div className="qr-wrapper">
          <div className="model-container shadow-lg" ref={modalRef}>
            <div className="upper-modal">
              <div>
                <div className="scan-text">SCAN</div>
                <div className="more-menu-text">To view our menu</div>
              </div>
              <div>
                <div className="powered-by-text">POWERED</div>
                <div className="powered-by-text">BY</div>
              </div>
            </div>

            <div className="lower-modal">
              <div className="qr-code">
                <QRCodeCanvas
                  value={url}
                  size={180}
                  bgColor="#f0f7ff"
                  fgColor="#000000"
                  level="H"
                />
              </div>

              <div className="logo">
                <img
                  src={sebs}
                  className="restro-logo"
                  crossOrigin="anonymous"
                />
              </div>
            </div>
          </div>

          {/* BUTTON JUST BELOW CARD */}
          <div className="action-buttons d-print-none">
            <Button className="action-btn" onClick={handlePrint}>
              Print QR
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};
